import signalRService from "../signalRService";
import { getStepName } from "./stepMappings";

class UserNavigationTracker {
  constructor() {
    this.isActive = false;
    this.userId = null;
    this.sessionId = null;
    this.tipoCliente = null;
    this.currentStep = null;
    this.currentView = null;
    this.lastEventTime = null;
    this.throttleMs = 1000;
  }

  startTracking(userId, tipoCliente, sessionId) {
    this.isActive = true;
    this.userId = userId;
    this.tipoCliente = tipoCliente;
    this.sessionId = sessionId || `session_${Date.now()}_${userId}`;
    console.log("🎯 NavigationTracker: Iniciado", {
      userId,
      tipoCliente,
      sessionId: this.sessionId,
      isActive: this.isActive,
    });
  }

  stopTracking() {
    console.log("⏹️ NavigationTracker: Parando tracking", {
      wasActive: this.isActive,
      userId: this.userId,
      sessionId: this.sessionId,
    });
    this.isActive = false;
  }

  trackStepChange(stepNumber, context = {}) {
    console.log("📊 NavigationTracker: trackStepChange chamado", {
      isActive: this.isActive,
      stepNumber,
      context,
    });

    if (!this.isActive) {
      console.warn("⚠️ NavigationTracker: Não ativo - ignorando");
      return;
    }

    const now = Date.now();

    if (
      this.currentStep === stepNumber &&
      this.lastEventTime &&
      now - this.lastEventTime < this.throttleMs
    ) {
      console.log(
        "⏱️ NavigationTracker: Throttled - mesma etapa muito rápido",
        {
          currentStep: this.currentStep,
          stepNumber,
          timeSinceLastEvent: now - this.lastEventTime,
          throttleMs: this.throttleMs,
        },
      );
      return;
    }

    const stepName = getStepName(this.tipoCliente, stepNumber);
    const previousStep = this.currentStep;

    console.log("📋 NavigationTracker: Preparando evento", {
      stepNumber,
      stepName,
      previousStep,
      tipoCliente: this.tipoCliente,
    });

    const eventData = {
      userId: this.userId,
      sessionId: this.sessionId,
      tipoCliente: this.tipoCliente,
      viewType: context.view || this.currentView || "unknown",
      stepNumber: stepNumber,
      stepName: stepName,
      previousStep: previousStep,
      timestamp: new Date().toISOString(),
      metadata: {
        isEditing: context.editing || false,
        renovacaoCadastral: context.renovacao || false,
        completedSteps: context.completedSteps || [],
      },
    };

    console.log("📤 NavigationTracker: Enviando evento...", eventData);
    this.sendNavigationEvent(eventData);

    this.currentStep = stepNumber;
    this.lastEventTime = now;
    console.log("✅ NavigationTracker: Estado atualizado", {
      currentStep: this.currentStep,
      lastEventTime: this.lastEventTime,
    });
  }

  trackViewChange(viewName) {
    console.log("👁️ NavigationTracker: View change", {
      previousView: this.currentView,
      newView: viewName,
    });
    this.currentView = viewName;
  }

  async trackCadastroCompleted(context = {}) {
    console.log("🎉 NavigationTracker: trackCadastroCompleted chamado", {
      isActive: this.isActive,
      context,
    });

    if (!this.isActive) {
      console.warn("⚠️ NavigationTracker: Não ativo - ignorando conclusão");
      return;
    }

    const eventData = {
      userId: this.userId,
      sessionId: this.sessionId,
      tipoCliente: this.tipoCliente,
      eventType: "cadastro_completed",
      timestamp: new Date().toISOString(),
      metadata: {
        renovacaoCadastral: context.renovacao || false,
        completedSteps: context.completedSteps || [],
      },
    };

    console.log("📤 NavigationTracker: Enviando conclusão...", eventData);

    try {
      await signalRService.notifyCadastroCompleted(eventData);
      console.log("✅ NavigationTracker: Conclusão enviada, parando tracking");
      this.stopTracking();
    } catch (error) {
      console.error(
        "❌ NavigationTracker: Erro ao notificar conclusão:",
        error,
      );
    }
  }

  async sendNavigationEvent(eventData) {
    console.log(
      "🚀 NavigationTracker: Chamando signalRService.trackUserNavigation...",
    );
    try {
      await signalRService.trackUserNavigation(eventData);
      console.log("✅ NavigationTracker: Evento enviado via SignalR");
    } catch (error) {
      console.error("❌ NavigationTracker: Erro ao enviar evento:", error);
    }
  }
}

export default new UserNavigationTracker();
